import { render, staticRenderFns } from "./TifTurnoInfoPuntos.vue?vue&type=template&id=bfbd7e5a"
import script from "./TifTurnoInfoPuntos.vue?vue&type=script&lang=js"
export * from "./TifTurnoInfoPuntos.vue?vue&type=script&lang=js"
import style0 from "./TifTurnoInfoPuntos.vue?vue&type=style&index=0&id=bfbd7e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports